<template>
  <v-app-bar color="primary" app left v-if="breakpoint > 2" height="90">
    <v-app-bar-nav-icon
      v-if="breakpoint > 2"
      @click="onMenu"
      data-cy="app-bar-nav"
    >
    </v-app-bar-nav-icon>
    <div class="company">
      <a @click="onHome">
        <v-img
          class="logo"
          src="@/assets/duck.png"
          height="93"
          width="76"
          min-height="93"
          min-width="76"
        >
        </v-img>
      </a>
    </div>
    <v-divider class="mx-4" vertical></v-divider>
    <span class="route">{{ currentRoute }}</span>
    <v-spacer></v-spacer>
    <v-divider class="mx-4" vertical></v-divider>
    <v-container>
      <v-row >
        <v-col cols="12" xl="12" lg="12" md="0" sm="0">
          <v-row>
            <v-spacer></v-spacer>
            <social-buttons class="social" v-if="breakpoint > 2"></social-buttons>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <div v-for="item in menuItems" v-bind:key="item.id">
          <div class="menu-item">
            <v-menu offset-y v-if="item.subItems != 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" text>
                  <v-icon>{{ item.icon }}</v-icon
                  >{{ item.text }}
                </v-btn>
              </template>
              <v-list
                v-for="subItem in item.subItems"
                v-bind:key="subItem.id"
              >
                <v-list-item :to="subItem.to">
                  <v-list-item-title>
                    <v-icon>{{ subItem.icon }}</v-icon
                    >{{ subItem.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn text :to="item.to" v-else>
              <v-icon>{{ item.icon }}</v-icon
              >{{ item.text }}
            </v-btn>
          <v-spacer></v-spacer>
          </div>
        </div>
        <div class="menu-item">
            <v-btn text @click="onToggleLocalization">
              <v-icon>mdi-swap-horizontal</v-icon
              >{{ localize }}
            </v-btn>

        </div>

      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import breakpointMixin from "@/mixins/breakpointMixin"
import { Loader } from "@/constants";
import localizationService from "@/_services/localization-service";
import menuService from "@/_services/menu-service.js"
// import route from "@/router"
import store from "@/store"
import settingsService from "@/_services/settings-service";
import social from "@/components/app/social-buttons";

export default {
  name: "app-bar",

  components: {
    "social-buttons": social,
  },

  created() {
    // // console.log("appbar.created()");
    // this.currentTo = route.to;
    this.filterMenuItems();
  },

  data: () => ({
    currentRoute: "Home",
    currentFrom: {},
    currentTo: {},
    localize: "Espanola",
    title: settingsService.get("applicationName"),
    menuItems: [],
  }),

  methods: {
    filterMenuItems() {
      // // console.log("appBar.filterMenuItems()");
      var items = menuService.get(Loader.toolbar);
      this.menuItems = [];
      items.forEach((item) => {
        if(item.breakpoint <= this.breakpoint){
          this.menuItems.push(item);
        }
      });
      this.localize = store.getters.getLocalization ? "Espanola" : "English";
      this.title = store.getters.getLocalization ? settingsService.get("applicationName") : settingsService.get("applicationName");
    },
    
    onMenu() {
      // // console.log("onMenu()");
      store.commit("toggleDrawer");
    },

    onBreakpointUpdated() {
      this.filterMenuItems();
    },

    onHome() {
      if(this.$route.path != "/") {
        this.$router.push("/")
      }
    },

    onToggleLocalization() {
      // // console.log("onToggleLocalization");
      store.commit("toggleLocalization");
    },
  },

  mixins: [breakpointMixin],

  store,

  watch: {
    "$store.state.localization"() {
      this.filterMenuItems()
      this.currentRoute = localizationService.translate(this.currentTo.name);
    },

    "$store.state.user"() {
      this.filterMenuItems()
      this.currentRoute = localizationService.translate(this.currentTo.name);
    },

    $route: function (to, from) {
      // // console.log("Route changed from ", from, " to ", to);
      this.currentTo = to;
      this.currentFrom = from;
      this.currentRoute = localizationService.translate(to.name);
    },
  },
};
</script>
<style scoped>
.company {
  cursor: grab;
  font-size: 2em;
  
  width: 85px;
}
.menu-item {
  margin-top: -5px;
  margin-right: 10px;
}
.route {
  width: 250px;
}
.social {
  margin-top: -20px;
  margin-right: 20px;
}
</style>
